import React from 'react'

const PrintButton = props => {

    const print = () => {
        let scrollHeight = Math.max(
            document.body.scrollHeight, document.documentElement.scrollHeight,
            document.body.offsetHeight, document.documentElement.offsetHeight,
            document.body.clientHeight, document.documentElement.clientHeight
        );
        //console.log("height", scrollHeight)
        //window.print();
        let array = []
        for (let i = 0; i <= Math.ceil(scrollHeight / (props.sh || 1100)); ++i) {
            array.push(i);
        }
        let _final = props.sh ? array : (scrollHeight < 8000 ? array.slice(0, array.length - 2) : array)
        props.setWatermark(_final)
        setTimeout(() => {
            document.body.classList.remove('print-none')
            window.print();
        }, 100)


    }

    return (
        <button disabled={!props.ready} type="button" className="btn btn-sm btn-secondary" onClick={() => print()}><i className="fas fa-print" /> {!props.ready ? 'Preparing...' : 'Print this page'}</button>
    )
}

export default PrintButton